import dialogBottomSheetStore from '../model/dialog-bottom-sheet-store'
import { ShowDialog } from '../model/model'

const openDialog = (data: ShowDialog) =>
  dialogBottomSheetStore.onSetDialog(data)

const closeDialog = () => dialogBottomSheetStore.onHideDialog()

const dialogBottomSheetHandlers = {
  closeDialog,
  openDialog,
}

export function useDialogBottomSheet() {
  return dialogBottomSheetHandlers
}
